/** V12-A — Page Leads : onglets Prospects (regroupement virtuel) et Simulations (exhaustif). Lecture seule, isolation par courtier. */
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "@/components/Layout";
import { ProspectsTab } from "@/components/leads/ProspectsTab";
import { SimulationsTab } from "@/components/leads/SimulationsTab";
import { ProspectPanel } from "@/components/leads/ProspectPanel";

export default function Leads() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") === "simulations" ? "simulations" : "prospects";
  const [openKey, setOpenKey] = useState(sp.get("prospect") || null);
  const setTab = (t) => { sp.set("tab", t); setSp(sp, { replace: true }); };
  return (
    <Layout>
      <div className="space-y-4" data-testid="leads-page">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div><div className="overline">Acquisition</div><h1 className="text-2xl font-extrabold text-slate-900">Leads</h1>
            <p className="text-[13px] text-slate-500">Prospects regroupés virtuellement (téléphone, puis e-mail) et historique exhaustif des simulations. Aucune fusion, aucun dossier créé automatiquement.</p></div>
          <div className="inline-flex rounded-xl border border-slate-200 bg-white p-0.5" data-testid="leads-tabs">
            {[["prospects", "Prospects"], ["simulations", "Simulations"]].map(([k, l]) => (
              <button key={k} onClick={() => setTab(k)} data-testid={`leads-tab-${k}`} className={`px-4 h-9 rounded-lg text-[13px] font-bold transition-colors ${tab === k ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`}>{l}</button>
            ))}
          </div>
        </div>
        {tab === "prospects" ? <ProspectsTab onOpen={setOpenKey} initialKey={sp.get("prospect")} /> : <SimulationsTab />}
        <ProspectPanel prospectKey={openKey} onClose={() => setOpenKey(null)} />
      </div>
    </Layout>
  );
}
